'use strict';
console.log('TS v1.2.10');

const isPostLogin = document.location.search.indexOf('post_login') > 0;
var isVotabilityUserStatusChecked = false;

const validateField = function (el, char) {
  var isValid = el.value.trim().length > char;

  if (!isValid) {
    el.closest('fieldset').classList.add('has-error');
    el.closest('fieldset').setAttribute(
      'data-error',
      'To pole jest obowiązkowe'
    );
  } else {
    el.closest('fieldset').classList.remove('has-error');
    el.closest('fieldset').setAttribute('data-error', '');
  }
  return isValid;
};

const validateCheckbox = function (el) {
  if (!el.checked) {
    el.nextElementSibling.classList.add('has-error');
    el.classList.add('has-error');
  } else {
    el.nextElementSibling.classList.remove('has-error');
    el.classList.remove('has-error');
  }
  return el.checked;
};

const checkEmail = function (emailAddress) {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}))$/;
  return re.test(String(emailAddress).toLowerCase());
};

const validateEmail = function (email) {
  var isValid = checkEmail(email.value);

  if (!isValid) {
    email.closest('fieldset').classList.add('has-error');
    email
      .closest('fieldset')
      .setAttribute(
        'data-error',
        'To pole jest obowiązkowe'
      );
  } else {
    email.closest('fieldset').classList.remove('has-error');
    email.closest('fieldset').setAttribute('data-error', '');
  }
  return isValid;
};

const oneLoginFormSettings = function (btn, form) {
  btn.classList.add('logged-in');
  btn.setAttribute('data-text', 'jesteś zalogowany');
  form.querySelector('.form__inputs').classList.add('inputs-disabled');
  form.querySelectorAll('.form__inputs input').forEach((input) => {
    input.setAttribute('disabled', true);
  });
  btn.setAttribute('disabled', true);
};

const candidateClick = function (e) {
  const candidate = e.target.closest('li');
  candidate.parentNode.querySelectorAll('li').forEach((n) => {
    if (n == candidate) return;
    n.classList.remove('candidate--selected');
  });
  candidate.classList.toggle('candidate--selected');
  //if (!isVotabilityUserStatusChecked) {
  getUserStatus();
  setEmbedSize();
  //}
};

const setEmbedSize = function () {
  window.parent.postMessage('TopserialeHeight:' + document.body.offsetHeight, '*');
};
/*
const setLiEvents = function (form) {

  lis.forEach(function (candidateSelect) {

    candidateSelect.addEventListener('click', function () {
      if (form.querySelector('.candidate__select li.candidate--selected')) {
        form
          .querySelector('.candidate__select li.candidate--selected')
          .classList.remove('candidate--selected');
      }
      if (
        form
          .querySelector('.candidate__select')
          .classList.contains('candidate__select--error')
      ) {
        form
          .querySelector('.candidate__select')
          .classList.remove('candidate__select--error');
      }
      this.classList.add('candidate--selected');
      document.querySelector('#form__voting_fields').scrollIntoView({"behavior": "smooth"});
      if (!isVotabilityUserStatusChecked) {
        getUserStatus();
      }
    });
  });
};
*/

const fetchCandidates = function (url, container) {
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const form = container.closest('form');
      container.innerHTML = html;
      container.classList.remove('candidate__select--marked');
      //form.querySelector('.form__data').classList.remove('form__data--visible');
      //form.querySelector('.show-form').classList.remove('show-form--hidden');

      //odtwarzanie sekcji buttons i checkboxa do stanu początkowego
      form.querySelector('.buttons').style.display = 'flex';
      form.querySelector('#agree-1').checked = false;

      //getUserStatus();

      document.querySelectorAll('fieldset.agrees .has-error').forEach((el) => {
        el.classList.remove('has-error');
      });

    })
    .catch((err) => {
      // console.log('Error', err);
    });
};

//var owlLogosSection = $('.owl-logos-section');
//owlLogosSection.owlCarousel({
//  loop: true,
//  nav: false,
//  autoWidth: true,
//  center: false,
//  autoplay: true,
//  slideTransition: 'linear',
//  autoplayTimeout: 3000,
//  autoplaySpeed: 3000,
//  autoplayHoverPause: true,
//  responsive: {
//    0: { margin: 32, items: 1, center: true },
//    340: { margin: 32, items: 1, center: true },
//    769: { margin: 48, items: 1, center: true },
//  },
//});

// sendPV = function () {
//   //wyślij statystykę pageview standard

//   wp_dot_addparams.ctags = statData[firstArticleSlug].tags;

//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//     event: "pageview",
//     page: {
//       "pageviewType": "standard",
//       "templateType": "AS"
//     },
//     site: {
//       "name": basicStatData.ga.site.name,
//       "version": basicStatData.ga.site.version,
//       "cms": basicStatData.ga.site.cms,
//       "as": { "orderId": asorderid, "productName": asproduct, "name": asname }
//     },
//     content: {
//       "title": statData[firstArticleSlug].title + ' ' + activeSlug,
//       "category": {
//         IAB: statData[firstArticleSlug].category.IAB,
//         Gemius: statData[firstArticleSlug].category.Gemius
//       },
//       "tags": statData[firstArticleSlug].tags
//     }
//   });
// }


  // (function () {
  //   setTimeout(
  //     sendPV, 1000);
  // })